import React from 'react';
import PropTypes from 'prop-types';
import { Text, RichText, Image } from '@sitecore-jss/sitecore-jss-react';
import SmallImageWithTextWrapper from './SmallImageWithText.styles';
import { ContentCol, StyledHeading, StyledText, GridWrapper, ImageCol } from './SmallImageWithText.styles';

const SmallImageWithText = ({ fields = {}, params = {} }) => {
  const {
    image,
    heading,
    text,
  } = fields;

  const {
    backgroundColor = 'transparent',
    headingColor = null,
    textColor = null,
    componentclass = '',
    id = null,
    backgroundHex = null,
  } = params;

  return (
    <SmallImageWithTextWrapper
      backgroundColor={backgroundHex ? undefined : backgroundColor}
      backgroundHex={backgroundHex}
      className={componentclass}
      id={id}
    >
      <GridWrapper>
        <ImageCol>
        {fields?.image?.value?.src && (
          <Image field={fields?.image} className="small-image" />
        )}
        </ImageCol>
        <ContentCol>
          {heading && (
            <StyledHeading headingColor={headingColor}>
              <Text field={fields?.heading} tag="h2" />
            </StyledHeading>
          )}
          {text && (
            <StyledText textColor={textColor}>
              <RichText field={fields?.text} />
            </StyledText>
          )}
        </ContentCol>
      </GridWrapper>
    </SmallImageWithTextWrapper>
  );
};

SmallImageWithText.propTypes = {
  fields: PropTypes.shape({
    image: PropTypes.object,
    heading: PropTypes.shape({ value: PropTypes.string }),
    text: PropTypes.shape({ value: PropTypes.string }),
  }),
  params: PropTypes.shape({
    backgroundColor: PropTypes.string,
    headingColor: PropTypes.string,
    textColor: PropTypes.string,
    componentclass: PropTypes.string,
    id: PropTypes.string,
  }),
};

export default SmallImageWithText;